import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { propType } from 'graphql-anywhere'
import { propOr } from 'ramda'
import classnames from 'classnames'

import { TARGET_TYPES, UUID_SLUG } from '../../constants'
import { getDetailsUrl } from '../../lib/utils'

import HIGHLIGHTED_CONTENT_FRAGMENT from '../../../graphql/fragments/highlighted-content.gql'

import TileSlide from '../tile-slide'

import styles from './highlighted-content.css'

/*
* HighlightedContentComponent on logged out home page
*/

function HighlightedContentComponent({ highlightedContent }) {
  const [showItemIndex, setShowItemIndex] = useState(0)
  const handleShowItemIndex = (showItem) => {
    setShowItemIndex(showItem)
  }
  const showContentItem = highlightedContent.tiles?.[showItemIndex]?.contentItem

  const cta = propOr({}, 'cta', highlightedContent)
  const ctaType = propOr('', 'type', cta)
  const ctaTarget = propOr('', 'target', cta)
  const ctaText = propOr('', 'text', cta)
  let navLinkTo = ctaTarget
  if (ctaType === TARGET_TYPES.SCREEN_ID) {
    navLinkTo = `/${UUID_SLUG}/${ctaTarget}`
  } else if (ctaType === TARGET_TYPES.SHOWPAGE) {
    navLinkTo = getDetailsUrl(showContentItem)
  }

  const isRental = showContentItem?.isRental && ctaType === TARGET_TYPES.SHOWPAGE

  return (
    <div className={styles.backgroundGradient}>
      <div className={styles.highlightedContentWrapper}>
        <div className={styles.tileSlideWrapper}>
          <TileSlide tiles={highlightedContent.tiles} handleChange={handleShowItemIndex} />
        </div>
        <div className={styles.infoWrapper}>
          <div className={styles.header}>
            {highlightedContent.header}
          </div>
          <div className={styles.description}>
            {highlightedContent.description}
          </div>
          {ctaType && (
            ctaType === TARGET_TYPES.EXTERNAL_URL ? (
              <a
                className={styles.cta}
                href={ctaTarget}
                target="_blank"
                rel="noopener noreferrer"
              >
                {ctaText}
              </a>
            ) : (
              <NavLink
                to={navLinkTo}
                className={classnames(styles.cta, {
                  [styles.isRental]: isRental
                })}
              >
                {ctaText}
              </NavLink>
            )
          )}
        </div>
      </div>
    </div>
  )
}

HighlightedContentComponent.propTypes = {
  highlightedContent: propType(HIGHLIGHTED_CONTENT_FRAGMENT).isRequired
}

export default HighlightedContentComponent
